"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Milestone = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Message = require("../Message");
var _Text = require("../Text");
var _LocaleProvider = require("../LocaleProvider");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('milestone-v2');
var Milestone = function Milestone(props) {
  var isCollapsed = props.isCollapsed,
    currentIndex = props.currentIndex,
    previewMockData = props.previewMockData,
    shouldHandleDateVariable = props.shouldHandleDateVariable,
    handleVariableShow = props.handleVariableShow,
    handleVariableHide = props.handleVariableHide;
  var richtextProps = {
    previewMockData: previewMockData,
    shouldHandleDateVariable: shouldHandleDateVariable,
    handleVariableShow: handleVariableShow,
    handleVariableHide: handleVariableHide
  };
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var submitText = trans('chatbot_taskflow_timeline_submit') || 'Submitted on';
  var milestones = props.milestones.map(function (v) {
    var _v$description;
    if ((_v$description = v.description) !== null && _v$description !== void 0 && _v$description.buttonGroup) {
      if (v.isFuture || props.disabled) {
        v.description.buttonGroup.disabled = true;
        v.description.disableSpecialLink = true;
        v.description.buttonGroup.buttons.forEach(function (btn) {
          btn.disabled = true;
        });
      }
      v.description.buttonGroup.className = "".concat(PREFIX, "-button-group");
      v.description.buttonGroup.buttons.forEach(function (btn) {
        btn.children = /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(PREFIX, "-button-group__scale")
        }, btn.text);
      });
    }
    return _objectSpread(_objectSpread({}, v), {}, {
      description: v.description
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)(PREFIX, (0, _defineProperty2.default)({}, "".concat(PREFIX, "__collapsed"), isCollapsed))
  }, milestones.map(function (v, index) {
    var _clsx2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx4.default)("".concat(PREFIX, "-item"), (_clsx2 = {}, (0, _defineProperty2.default)(_clsx2, "".concat(PREFIX, "-item__future"), v.isFuture), (0, _defineProperty2.default)(_clsx2, "".concat(PREFIX, "-item__current"), index === currentIndex), _clsx2)),
      key: v.dateText
    }, /*#__PURE__*/_react.default.createElement(Divider, {
      isFuture: v.isFuture
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "-item-content")
    }, /*#__PURE__*/_react.default.createElement(_Text.Text, (0, _extends2.default)({
      content: v.title,
      className: "".concat(PREFIX, "-item-title")
    }, richtextProps)), v.dateText && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "-item-date")
    }, /*#__PURE__*/_react.default.createElement("span", null, submitText), " ", /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(PREFIX, "-item-date-text")
    }, v.dateText)), v.description && /*#__PURE__*/_react.default.createElement(_Message.Message, (0, _extends2.default)({}, v.description, {
      className: "".concat(PREFIX, "-item-rich-text")
    }, richtextProps))));
  }));
};
exports.Milestone = Milestone;
var Divider = function Divider(props) {
  var isFuture = props.isFuture;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)("".concat(PREFIX, "-item-divider"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-item-divider__future"), isFuture))
  }, props.isFuture ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-item-divider-future")
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-item-divider-past")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-item-divider-line")
  }));
};